const STATUS_LABELS = {
    processing: 'В обработке',
    requires_review: 'Нужна проверка',
    succeeded: 'Завершено',
    refunded: 'Возвращено',
};
export function resolutionStatusLabel(status) {
    return STATUS_LABELS[status] ?? status;
}
export function resolutionStatusTone(status) {
    if (status === 'requires_review')
        return 'warn';
    if (status === 'succeeded' || status === 'refunded')
        return 'ok';
    return 'neutral';
}
const DATE_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
    dateStyle: 'short',
    timeStyle: 'short',
});
export function formatResolutionDate(value) {
    if (!value)
        return '—';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : DATE_FORMATTER.format(date);
}
